import React from "react";
import isApp from "shared/util/isApp";
import { isDesktop } from "shared/util/EnvironmentHelpers";
import Str from "shared/components/Str";
import Strf from "shared/components/Strf";
import classnames from "classnames";

const linkAttrs = {
	className: classnames({
		"terms-of-service-link": true,
		"js-external-link": isApp(),
	}),
	target: "_blank",
};

const tos = isApp() ? (
	<a {...linkAttrs} href="/legal/terms">
		<Str>Terms</Str>
	</a>
) : (
	<a {...linkAttrs} href="https://okcupid.com/legal/terms">
		<Str>Terms</Str>
	</a>
);

const privacy = isApp() ? (
	<a {...linkAttrs} href="/legal/privacy">
		<Str>Privacy Policy</Str>
	</a>
) : (
	<a {...linkAttrs} href="https://okcupid.com/legal/privacy">
		<Str>Privacy Policy</Str>
	</a>
);

const cookie = isApp() ? (
	<a {...linkAttrs} href="/legal/cookies">
		<Str>Cookies Policy</Str>
	</a>
) : (
	<a {...linkAttrs} href="https://okcupid.com/legal/cookies">
		<Str>Cookies Policy</Str>
	</a>
);

const TermsOfService = () => (
	<Strf
		className="terms-of-service"
		vars={{
			action: isDesktop ?
				<Str>clicking</Str> : <Str>tapping</Str>,
			tos,
			privacy,
			cookie,
		}}
	>
		By $action Join, you agree to our $tos.
		Learn how we process your data in our $privacy and $cookie.
	</Strf>
);

export default TermsOfService;



// WEBPACK FOOTER //
// ./src/shared/components/TermsOfService.jsx